/* eslint-disable */

//tslint:disable

import { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api/shared/http';
import {
  TGetNewbuildingsCountForSerpModel,
  IGetNewbuildingsCountForSerpRequest,
  IMappers,
  IGetNewbuildingsCountForSerpResponse,
  IGetNewbuildingsCountForSerpResponseError,
  TGetNewbuildingsCountForSerpResponse,
} from './types';

const defaultConfig: TGetNewbuildingsCountForSerpModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  method: 'POST',
  microserviceName: 'newbuilding-search',
  pathApi: '/v1/get-newbuildings-count-for-serp/',
  hostType: 'api',
} as TGetNewbuildingsCountForSerpModel;

function createGetNewbuildingsCountForSerpModel(
  parameters: IGetNewbuildingsCountForSerpRequest,
): TGetNewbuildingsCountForSerpModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IGetNewbuildingsCountForSerpOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  parameters: IGetNewbuildingsCountForSerpRequest;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
}

async function fetchGetNewbuildingsCountForSerp<TResponse200, TResponse400>({
  httpApi,
  parameters,
  config,
  mappers,
}: IGetNewbuildingsCountForSerpOptions<TResponse200, TResponse400>): Promise<
  TResponse200 | TResponse400 | TGetNewbuildingsCountForSerpResponse
> {
  const { response, statusCode } = await httpApi.fetch(createGetNewbuildingsCountForSerpModel(parameters), config);

  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IGetNewbuildingsCountForSerpResponse);
    }

    if (statusCode === 400) {
      return mappers[400](response as IGetNewbuildingsCountForSerpResponseError);
    }
  }

  return { response, statusCode } as TGetNewbuildingsCountForSerpResponse;
}

export { defaultConfig, createGetNewbuildingsCountForSerpModel, fetchGetNewbuildingsCountForSerp };
